import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Bild } from "./Bild";
import { START } from "../lib/inhalte";

export const Leistungen = () => {
  const l = START.leistungen;
  return (
    <section id="leistungen" data-testid="leistungen" className="bg-stein-100 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="text-sm font-semibold text-chemara-violet mb-2">{l.label}</div>
        <h2 className="font-heading text-3xl md:text-5xl text-stein-900 leading-tight">{l.titel}</h2>
        <div className="mt-8 md:mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {l.items.map((i) => (
            // Antippen öffnet die Anfrage mit dieser Leistung
            <Link key={i.id} to={`/offerte?leistung=${i.id}`} data-testid={`leistung-${i.id}`}
              className="group bg-white rounded-xl overflow-hidden border border-stein-200 shadow-sm hover:shadow-md hover:border-stein-300 transition-all">
              <Bild id={i.bild} className="aspect-[16/10] w-full" />
              <div className="p-5 flex items-center justify-between gap-3">
                <h3 className="font-heading text-xl text-stein-900">{i.titel}</h3>
                <ArrowRight size={20} className="shrink-0 text-chemara-violet transition-transform group-hover:translate-x-1" />
              </div>
            </Link>
          ))}
        </div>
        <p className="mt-6 text-sm text-stein-500">{l.hinweis}</p>
        <div className="mt-10 rounded-xl bg-stein-200 p-6 md:p-8">
          <div>
            <div className="font-heading text-xl md:text-2xl text-stein-900">{START.fuer.titel}</div>
            <div className="mt-1 text-stein-700">{START.fuer.gebiet}</div>
          </div>
        </div>
      </div>
    </section>
  );
};
